import { List, ListProps } from "@mui/material";

import { ToolbarFlowOrientation } from "../../../Settings/settingsTypes";
import { useSettings } from "../../../Settings/useSettings";


const CustomList = (props: ListProps) => {

    const settings = useSettings();
    const orientation = settings.ui.toolbarFlowOrientation;

    const className = orientation === ToolbarFlowOrientation.RightHanded ? 'list_ltr' : 'list_rtl';

    return (
        <List {...props} className={className} />
    );
};

export default CustomList;